import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { intlMessage } from 'constants/propTypes';
import { ICONS } from 'constants/icons';
import Callout from 'components/Callout';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';
import When from 'components/When';
import { selectIsMobile } from 'selectors/ui';
import appMessages from 'features/App/App.messages';

import GuidancePanelContent from './GuidancePanelContent';
import messages from '../ReservationFeedbackModalV2.messages';

import './SuccessReport.scss';

const { block, element } = bem('success-report');

const SuccessReport = ({ guidelines, payoutBannerIcon, payoutBannerMessage, venueId, reservationId }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const isMobile = useSelector(selectIsMobile);
  const closeAriaLabel = intl.formatMessage(appMessages.close);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <div className={block()}>
      <div className={element('success-panel')}>
        <When predicate={isMobile}>
          <div className={element('close-button')}>
            <button
              type="button"
              onClick={handleClose}
              name="close-button"
              aria-label={closeAriaLabel}
              className={element('close-icon')}>
              <Isvg src={ICONS.cross} />
            </button>
          </div>
        </When>
        <div className={element('success-content')}>
          <div className={element('icon-wrapper')}>
            <Isvg src={ICONS.checkmarkInCircleThickGreen} />
          </div>
          <div className={element('text-wrapper')}>
            <h3 className={element('title')}>
              <Message message={messages.successReportTitle} />
            </h3>
            <p className={element('description')}>
              <Message message={messages.successReportDescription} />
            </p>
          </div>
        </div>
        <div className={element('payout-banner')}>
          <Callout icon={<Isvg src={payoutBannerIcon} />}>
            <Message message={payoutBannerMessage} />
          </Callout>
        </div>
      </div>
      <div className={element('guidance-panel')}>
        <When predicate={!isMobile}>
          <div className={element('close-button')}>
            <button
              type="button"
              onClick={handleClose}
              name="close-button"
              aria-label={closeAriaLabel}
              className={element('close-icon')}>
              <Isvg src={ICONS.cross} />
            </button>
          </div>
        </When>
        <div className={element('guidance-content')}>
          <Message as="h2" className={element('guidance-title')} message={messages.successWhatHappensNext} />
          <div className={element('guidance-wrapper')}>
            <GuidancePanelContent guidelines={guidelines} venueId={venueId} reservationId={reservationId} />
          </div>
        </div>
      </div>
    </div>
  );
};

SuccessReport.propTypes = {
  guidelines: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.oneOfType([intlMessage, PropTypes.arrayOf(intlMessage)]).isRequired,
      icon: PropTypes.string.isRequired,
      iconModifier: PropTypes.string,
      title: intlMessage.isRequired,
    })
  ).isRequired,
  payoutBannerIcon: PropTypes.string.isRequired,
  payoutBannerMessage: intlMessage.isRequired,
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SuccessReport;
